import { render } from "./BFaceSectionDisp.vue?vue&type=template&id=35d9cb80&scoped=true"
import script from "./BFaceSectionDisp.vue?vue&type=script&lang=js"
export * from "./BFaceSectionDisp.vue?vue&type=script&lang=js"

import "./BFaceSectionDisp.vue?vue&type=style&index=0&id=35d9cb80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35d9cb80"

export default script